/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// document.addEventListener('DOMContentLoaded', function() {
//     // Wait for the Instafeed script to render
//     function moveInstafeedToGallery() {
//         const feedContainer = document.querySelector('#insta-feed .instafeed-new-layout-wrapper');
//         const galleryList = document.querySelector('.gallery__list');

//         if (!feedContainer || !galleryList) return;

//         // Remove first three existing gallery items
//         const existingItems = galleryList.querySelectorAll('gallery-item');
//         existingItems.forEach((item, index) => {
//             if(index < 3) item.remove();
//         });

//         const items = feedContainer.querySelectorAll('.instafeed-new-layout-item');

//         items.forEach(item => {
//             const img = item.querySelector('img');
//             const link = item.querySelector('a') ? item.querySelector('a').href : '#';
//             const caption = img ? img.alt : '';
//             const imgSrc = img.dataset.instafeedSrc || img.src;

//             console.log(imgSrc);

//             // Create the same gallery-item structure
//             const galleryItem = document.createElement('gallery-item');
//             galleryItem.className = 'gallery__item';

//             galleryItem.innerHTML = `
//                 <a href="${link}" target="_blank">
//                     <figure class="gallery__figure">
//                         <img src="${imgSrc}" alt="${caption}" class="gallery__image">
//                         <div class="instafeed-hover-layer">
//                             <div class="instafeed-hover-icon">
//                                 <img src="https://instafeed.nfcube.com/assets/img/instagram-icon-v2.svg">
//                             </div>
//                         </div>
//                     </figure>
//                 </a>
//             `;

//             galleryList.appendChild(galleryItem);
//         });

//         // Remove original Instafeed container to avoid duplicates
//         const instaFeed = document.getElementById('insta-feed');
//         if(instaFeed) instaFeed.remove();
//     }

//     // Wait a bit to make sure Instafeed has loaded
//     setTimeout(moveInstafeedToGallery, 1500);
// });

// Filter accordion: collapse other groups when one opens
document.addEventListener('click', function(event) {
  var btn = event.target.closest('.product-facet__filter-list .collapsible-toggle');
  if (!btn) return;
  // ToggleButton already ran and updated aria-expanded — if it's now "true", this group just opened
  if (btn.getAttribute('aria-expanded') !== 'true') return;
  var filterList = btn.closest('.product-facet__filter-list');
  if (!filterList) return;
  filterList.querySelectorAll('.collapsible-toggle[aria-expanded="true"]').forEach(function(other) {
    if (other !== btn) other.click();
  });
});

document.addEventListener('DOMContentLoaded', function() {
  function moveInstafeedToGallery() {
    const feedContainer = document.querySelector('#insta-feed .instafeed-new-layout-wrapper');
    const galleryList = document.querySelector('.gallery__list');
    if (!feedContainer || !galleryList) return;
    const existingItems = galleryList.querySelectorAll('gallery-item');
    existingItems.forEach((item, index) => { if (index < 3) item.remove(); });

    const items = feedContainer.querySelectorAll('.instafeed-new-layout-item');

    items.forEach(item => {
      const img = item.querySelector('img');
      const link = item.querySelector('a') ? item.querySelector('a').href : '#';
      const caption = img ? img.alt : '';
      const imgSrc = img?.dataset?.instafeedSrc || img?.src || '';

      const galleryItem = document.createElement('gallery-item');
      galleryItem.className = 'gallery__item';
      galleryItem.innerHTML = `
        <a href="${link}" target="_blank">
          <figure class="gallery__figure">
            <img src="${imgSrc}" alt="${caption}" class="gallery__image">
            <div class="instafeed-hover-layer">
              <div class="instafeed-hover-icon">
                <img src="https://instafeed.nfcube.com/assets/img/instagram-icon-v2.svg">
              </div>
            </div>
          </figure>
        </a>
      `;

      const anchor = galleryItem.querySelector('a');

      anchor.addEventListener('click', function(e) {
        const scrollableContainer = galleryList.closest('scrollable-content');
        if (scrollableContainer && (scrollableContainer.preventClick || scrollableContainer.drag)) {
          e.preventDefault();
          e.stopPropagation();
        }
      });

      galleryList.appendChild(galleryItem);
    });

    const instaFeed = document.getElementById('insta-feed');
    if (instaFeed) instaFeed.remove();
  }

  const observer = new MutationObserver(() => {
    const feedItems = document.querySelectorAll('#insta-feed .instafeed-new-layout-item');

    if (feedItems.length > 0) {
      observer.disconnect(); // Stop observing
      moveInstafeedToGallery(); // ✅ Run only when feed is fully loaded
    }
  });

  // Observe the entire body for dynamic Instafeed injection
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Rulează doar pe mobile
  if (window.innerWidth > 768) return;

  document.querySelectorAll('.footer__item').forEach(item => {

    // Sari peste secțiunea Social Media
    if (item.classList.contains('footer__item--social-media')) return;

    const title = item.querySelector('.footer__item-title');
    const content = item.querySelector('.footer__item-content');

    if (!title || !content) return;

    // Creează săgeata
    const arrow = document.createElement('span');
    arrow.classList.add('footer-toggle-arrow');
    title.appendChild(arrow);

    // Ascunde conținutul
    content.style.display = "none";

    // Toggle la click
    title.addEventListener('click', () => {
      const isOpen = item.classList.toggle('open');
      content.style.display = isOpen ? "block" : "none";
    });
  });
});

// Match product__info height to product__media on desktop
// (function () {
//   function matchProductInfoHeight() {
//     if (window.innerWidth < 1000) return;
//     const media = document.querySelector('.product__media');
//     const info  = document.querySelector('.product__info');
//     if (!media || !info) return;
//     info.style.height = media.offsetHeight + 'px';
//   }

//   document.addEventListener('DOMContentLoaded', matchProductInfoHeight);
//   window.addEventListener('resize', matchProductInfoHeight);
// })();

// Match product__info height to product__media on desktop
(function () {
  function matchProductInfoHeight() {
    if (window.innerWidth < 1000) return;
    const media = document.querySelector('.product__media-image-wrapper');
    const info  = document.querySelector('.product__info');
    if (!media || !info) return;
    info.style.height = media.offsetHeight + 'px';
  }

  document.addEventListener('DOMContentLoaded', matchProductInfoHeight);
  window.addEventListener('resize', matchProductInfoHeight);
})();



/* Judge.me product reviews (PDP): show dates as "JUL 30, 2026".
   Judge.me only offers numeric formats (mm/dd/yyyy...) or "x days ago", so the date it
   writes is reformatted from the raw timestamp it keeps in data-content. Same format as
   the homepage reviews carousel. Reviews arrive late and on every page/sort change,
   hence the observer. */
(function () {
  var locale = document.documentElement.lang || 'en';

  function format(raw) {
    if (!raw) return '';
    var date = new Date(raw.replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(date.getTime())) return '';
    try {
      return date.toLocaleDateString(locale, { month: 'short', day: '2-digit', year: 'numeric' }).toUpperCase();
    } catch (e) {
      return '';
    }
  }

  function reformat() {
    document.querySelectorAll('.jdgm-widget .jdgm-rev__timestamp[data-content]').forEach(function (el) {
      // Judge.me fills the text in after rendering; wait until it has.
      if (el.classList.contains('jdgm-spinner')) return;
      var text = format(el.getAttribute('data-content'));
      if (text && el.textContent !== text) el.textContent = text;
    });
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      reformat();
    });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  reformat();
})();
